import styled from 'styled-components';
import { Box } from '../Core';

export const Wrapper = styled(Box)`
  display: inline-flex;
  white-space: nowrap;
  gap: calc(var(--spacing4) * 1px);
  align-items: center;
`;
